import { List } from 'immutable';
import { PaymentStatus } from '../models/payment-status.enum';

export class PaymentStatusUtils {

  static readonly ERROR_CODES = List<PaymentStatus>([
    PaymentStatus.INVOICE_REJECTED,
    PaymentStatus.PAY_REJECTED,
    PaymentStatus.ERROR
  ]);

  static readonly NO_TOTAL_PAID_CODES = List<PaymentStatus>([
    PaymentStatus.INVOICE_REJECTED,
    PaymentStatus.PAY_REJECTED,
    PaymentStatus.CHECK_STOPPED,
    PaymentStatus.REQUESTED,
    PaymentStatus.ERROR,
    PaymentStatus.REQUEST_REJECTED,
    PaymentStatus.RESENT_REQUEST,
    PaymentStatus.CANCELLED
  ]);

  static readonly NO_ESTIMATED_DUE_CODES = List<PaymentStatus>([
    PaymentStatus.READY,
    PaymentStatus.PENDING,
    PaymentStatus.INVOICED,
    PaymentStatus.FUNDED,
    PaymentStatus.PAY_SENT,
    PaymentStatus.PAID_DIRECT,
    PaymentStatus.CANCELLED,
    PaymentStatus.CHECK_STOPPED,
    PaymentStatus.PAY_CLEARED,
    PaymentStatus.PAY_REISSUED
  ]);

  static readonly NOT_EDITABLE_CODES = List<PaymentStatus>([
    PaymentStatus.READY,
    PaymentStatus.PENDING,
    PaymentStatus.INVOICED,
    PaymentStatus.FUNDED,
    PaymentStatus.PAY_SENT,
    PaymentStatus.REQUESTED,
    PaymentStatus.RESENT_REQUEST,
    PaymentStatus.PAID_DIRECT,
    PaymentStatus.CANCELLED,
    PaymentStatus.CHECK_STOPPED,
    PaymentStatus.PAY_CLEARED,
    PaymentStatus.PAY_REISSUED
  ]);

  static isError(paymentStatus: PaymentStatus): boolean {
    return this.ERROR_CODES.contains(paymentStatus);
  }

  static isNoTotalPaid(paymentStatus: PaymentStatus): boolean {
    return this.NO_TOTAL_PAID_CODES.contains(paymentStatus);
  }

  static isNoEstimatedDue(paymentStatus: PaymentStatus): boolean {
    return this.NO_ESTIMATED_DUE_CODES.contains(paymentStatus);
  }

  static isEditable(paymentStatus: PaymentStatus): boolean {
    return this.NOT_EDITABLE_CODES.contains(paymentStatus);
  }

  static getAwePaymentStatus(paymentStatus: PaymentStatus, isAgencyUser: boolean): PaymentStatus {
    return isAgencyUser && paymentStatus === PaymentStatus.REJECTED_WF_APPROVAL ? PaymentStatus.PENDING_WF_APPROVAL : paymentStatus;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/payment-status-utils.ts